import * as React from 'react';
import { observable } from 'mobx';
import { PageStep, EVENT_RESERVATION_STEPS, EventReservationPageState } from './states/EventReservationPageState';
import { InputStep } from './InputStep';
import { ConfirmationStep } from './ConfirmationStep';
import { CompleteStep } from './CompleteStep';
import './eventReservationPage.module.scss';
import { observer } from 'mobx-react';
import { GlobalStates } from '../../states/globalStates';
import { ErrorStep } from '../common/ErrorStep';
import { StepPage, StepPageBody, StepPageHeader, StepPageMain, StepPageSide } from '../common/stepPage';
import { StepIndicator } from '../common/stepPage/StepIndicator';
import { GlobalLoader } from '../../../main/containers/common/GlobalLoader';
import { NotFoundPage } from '../common/NotFoundPage';
import { FloatingEventInfo } from './components/FloatingEventInfo';
import { withNavigation } from '../../../mainv3/components/hocs/withNavigation';
import { NavigationSpecs } from '../../../mainv3/states/NavigationState';

type StepProps = {
    pageState: EventReservationPageState;
};

const StepPane = ({ pageState }: StepProps) => {
    switch (pageState.currentStep) {
        case PageStep.INPUT:
            return <InputStep pageState={pageState} />;
        case PageStep.CONFIRMATION:
            return <ConfirmationStep pageState={pageState} />;
        case PageStep.COMPLETE:
            return <CompleteStep />;
        case PageStep.ERROR:
            return <ErrorStep errorMessage={pageState.errorMessage} />;
        default:
            throw new Error('Unsupported step : ' + pageState.currentStep);
    }
};

type Props = {
    match: {
        params: {
            eventId: string;
        };
    };
};

@withNavigation(NavigationSpecs.standard())
@observer
export default class EventReservationPage extends React.Component<Props> {
    @observable pageState = new EventReservationPageState();
    async componentDidMount() {
        const { eventId } = this.props.match.params;
        await this.pageState.init(Number(eventId), GlobalStates.currentUser);
    }
    render() {
        const { currentStep, loading, event, reserverType, membershipAvailable, appliedPrice } = this.pageState;
        if (loading) {
            return <GlobalLoader />;
        }
        if (event.isNotFound()) {
            return <NotFoundPage entityType="イベント" />;
        }
        return (
            <StepPage>
                <StepPageHeader>イベントを予約する</StepPageHeader>
                <StepPageBody>
                    <StepPageMain>
                        <StepIndicator
                            currentStep={currentStep.valueOf()}
                            steps={EVENT_RESERVATION_STEPS}
                            error={currentStep === PageStep.ERROR}
                        />
                        <StepPane pageState={this.pageState} />
                    </StepPageMain>
                    <StepPageSide>
                        {[PageStep.ERROR, PageStep.COMPLETE].indexOf(currentStep) < 0 && (
                            <FloatingEventInfo
                                event={event.get()}
                                reserverType={reserverType}
                                membershipAvailable={membershipAvailable}
                                appliedPrice={appliedPrice}
                            />
                        )}
                    </StepPageSide>
                </StepPageBody>
            </StepPage>
        );
    }
}
